import React from "react";
import BoardCheckbox from "./BoardCheckbox";

const BoardList = ({ boards, checkedList, onSelect, isEpic = false, ...props }) => {  
  return (
    <>
      {boards.map((board) => (
        <BoardCheckbox
          key={isEpic ? board?.epic_id : board?.board_id}
          board={board}
          checked={checkedList.includes(isEpic ? board?.epic_id : board?.board_id)}
          onSelect={onSelect}
          isEpic={isEpic}
          {...props}
        />
      ))}
    </>
  );
};

export default BoardList;